export const de = {
  houseDetailPage: {
    sections: {
      details: {
        overview: {
          headline: 'Allgemein',
          labels: {
            living_area_total: 'Wohnfläche',
            number_rooms: 'Zimmer',
            expansion_stage_display: 'Ausbaustufe',
            construction_method_name: 'Bauweise',
            utilization_name: 'Hausart',
            funding: 'Förderung',
            number_storeys: 'Etagen',
            outside_measurements: 'Außenmaße',
            features: 'Merkmale'
          },
          values: {
            living_area_total: '{{area}} m²',
            outside_measurements_length: 'Länge: {{length}} m',
            outside_measurements_width: 'Breite: {{width}} m',
            expansion_stage: {
              fitting: 'Ausbauhaus',
              lego: 'Bausatzhaus',
              keyready: 'Schlüsselfertig'
            },
            funding: {
              kfn_funding: 'KFN',
              kfn_funding_qng: 'KFN mit QNG'
            }
          },
          tooltips: {
            expansion_stage: {
              fitting:
                'Bei einem Ausbauhaus (auch Mitbauhaus genannt) wird der Innenausbau komplett oder zu Teilen vom Bauherren selbst vorgenommen.',
              lego:
                'Hierbei handelt es sich um ein Selbstbauhaus. Das bedeutet, dass der Anbieter lediglich einen Bausatz liefert und der Bauherr sein gesamtes Haus in Eigenleistung errichtet. Auf Wunsch erhalten Sie Unterstützung durch den Anbieter.',
              keyready:
                'Der Bauherr erhält ein Haus, in das er fast einziehen kann. Es müssen nur noch letzte Innenausbauarbeiten, wie beispielsweise Wände streichen oder Böden verlegen vom Bauherren selbst ausgeführt werden.'
            },
            construction_method: {
              prefab:
                'Bei einem Fertighaus werden die Bauteile des Hauses im Werk vorgefertigt und im Anschluss auf dem Grundstück aufgestellt.',
              solid:
                'Ein Massivhaus wird nach dem "Stein-auf-Stein-Prinzip" auf der Baustelle aufgebaut.',
              blockhouse:
                'Ein Blockhaus wird in Holzbauweise aus massiven Holzbalken und -bohlen gebaut.'
            },
            funding: {
              kfn_funding:
                'Effizienz­haus 40 (oder besser), reduzierter CO2-Ausstoß gemäß Anforderungen an Treibhausgasemissionen des "Qualitäts­siegels Nachhaltiges Gebäude Plus", kein Heizen mit fossilen Brennstoffen oder Biomasse, Planung durch Energieeffizienz-/Nachhaltigkeitsfachkraft',
              kfn_funding_qng:
                'Effizienz­haus 40 (oder besser), Erfüllung der Kriterien des Qualitäts­siegels Nachhaltiges Gebäude Plus oder Premium, kein Heizen mit fossilen Brennstoffen oder Biomasse, Planung durch Energieeffizienz-/Nachhaltigkeitsfachkraft'
            }
          }
        },
        energy_standards: {
          headline: 'Energiestandard und Förderung',
          labels: {
            energy_standard: 'Energiestandard',
            heat_transfer_coefficient: 'Wärmedurchgangskoeffizient'
          },
          values: {
            kfw_55: 'Effizienzhaus 55',
            kfw_40: 'Effizienzhaus 40',
            positive_energy_house: 'Plusenergiehaus',
            kfw_40_plus: 'Effizienzhaus 40 Plus',
            kfw_40_ee: 'Effizienzhaus 40 EE',
            kfw_40_nh: 'Effizienzhaus 40 NH',
            kfw_55_ee: 'Effizienzhaus 55 EE',
            kfw_55_nh: 'Effizienzhaus 55 NH',
            heat_transfer_coefficient: '{{number}} (U-Wert)'
          },
          tooltips: {
            kfw_55:
              'Geringe Nebenkosten, dank hervorragender Dämmung. Rund 50% geringere Heizkosten ggü. konventionellen Häusern. ',
            kfw_40:
              'Bei einem Effizienzhaus 40 fallen die Heizkosten 60 % geringer aus, verglichen zu herkömmlichen Häusern.',
            positive_energy_house:
              'Ein Haus als grünes Kraftwerk - es erzeugt mehr Energie, als es verbraucht.',
            kfw_40_plus:
              'Eigene Energieerzeugung durch Solaranlagen & exzellente Wärmerückgewinnung - spart drastisch Heiz- und Nebenkosten.',
            kfw_40_ee:
              'Neuer Standard: Effizienzhaus 40 für Erneuerbare-Energien. Der Wärmeenergiebedarf muss zu mindestens 55 % aus erneuerbaren Energien gewonnen werden.',
            kfw_40_nh:
              'Neuer Standard: Effizienzhaus 40 für Nachhaltigkeit. Entspricht den Anforderungen des Nachhaltigkeitszertifikats „Qualitätssiegel Nachhaltiges Gebäude“ (QNG).',
            heat_transfer_coefficient:
              'Auch U-Wert genannt - verdeutlicht die Wärmedämmeigenschaft eines Bauteils oder Gebäudes. Es gilt: Je kleiner der U-Wert, desto besser.',
            kfw_55_ee:
              'Effizienzhaus 55, das zusätzlich mindestens 65 % der Heizenergie aus erneuerbaren Energien oder Abwärme bezieht.',
            kfw_55_nh:
              'Effizienzhaus 55, das zusätzlich den Anforderungen des QNG entspricht, d.h. geringe CO2-Emissionen & besondere Nachhaltigkeit.'
          },
          accordion: {
            headline: 'Was bedeuten die Energiestandards?',
            kfw_40_plus: {
              headline: 'Effizienzhaus 40 Plus',
              description:
                'Ein Effizienzhaus 40 Plus verbraucht im Vergleich zum Referenzhaus 100 > 60 % weniger Energie. Sie müssen für den Hausbau mit Mehrkosten von ~ 13,5 % rechnen, die sich aber mittelfristig auszahlen. Es verfügt im Vergleich zum Effizienzhaus 40 über weitere Komponenten, wie beispielsweise eine Lüftungsanlage mit Wärmerückgewinnung, eine Anlage, mit der auf Basis erneuerbarer Energien Strom erzeugt werden kann und ein Batteriespeichersystem, mit dem überschüssige Energie eingespart werden kann.'
            },
            kfw_40: {
              headline: 'Effizienzhaus 40',
              description:
                'Seit dem 1. Juli 2010 gibt es neben dem Effizienzhaus 55 und dem Effizienzhaus 70 noch das Effizienzhaus 40. Das Effizienzhaus 40 darf nur 40 Prozent der nach Energieeinsparverordnung 2009 (EnEV) gültigen Höchstwerte hinsichtlich Jahres-Primärenergiebedarf und Transmissionswärmeverlust erreichen. Neben der Einsparung von 60 Prozent beim Jahres-Primärenergiebedarfs sind auch beim Transmissionswärmeverlust 45 Prozent einzusparen. Der maximale Jahresprimärenergiebedarf beträgt 30 kWh/m². Ein KfW-Effizienzhaus 40 Haus ist luftdicht und nutzt regenerative Energien, häufig eine Kombination aus Holzpellets, Solaranlage und Lüftungsanlage mit Wärmerückgewinnung.'
            },
            kfw_55: {
              headline: 'Effizienzhaus 55',
              description:
                'Ein Effizienzhaus 55 verbraucht im Vergleich zum Referenzhaus 100 45 % weniger Energie. Sie müssen für den Hausbau mit Mehrkosten von ~ 7,5 % rechnen, die sich aber mittelfristig auszahlen. Diese Effizienzklasse gilt heutzutage als Standard für alle neu gebauten Häuser.'
            }
          }
        },
        funding: {
          accordion: {
            headline: 'Überblick: Welche Förderung gibt es?',
            kfn_funding: {
              headline: 'KFN Förderung',
              description:
                'KFN Förderung kann man erhalten, wenn das Haus ein Effizienz­haus 40 oder besser ist, einen reduzierten CO2-Ausstoß gemäß Anforderungen an Treibhausgasemissionen des "Qualitäts­siegels Nachhaltiges Gebäude Plus" hat und nicht mit fossilen Brennstoffen oder Biomasse geheizt wird. Die Planung des Hauses wird von einer Energieeffizienz-/Nachhaltigkeitsfachkraft durchgeführt.'
            },
            kfn_funding_qng: {
              headline: 'KFN Förderung mit QNG',
              description:
                'KFN Förderung mit QNG kann man erhalten, wenn das Haus ein Effizienz­haus 40 oder besser ist, einen reduzierten CO2-Ausstoß gemäß "Qualitäts­siegel Nachhaltiges Gebäude Plus" (max 28 kg CO² Äqu./m²a & höchstens 96 kWh/m²a Bedarf an nicht erneuerbarer Primärenergie) oder Premium (maximal 20 kg CO² Äqu./m²a & höchstens 64 kWh/m²a Bedarf an nicht erneuerbarer Primärenergie) hat und nicht mit fossilen Brennstoffen oder Biomasse geheizt wird. Die Planung des Hauses wird von einer Energieeffizienz-/Nachhaltigkeitsfachkraft durchgeführt.'
            }
          }
        },
        roof: {
          headline: 'Dach',
          labels: {
            roof_shape_name: 'Dachform',
            roof_pitch: 'Dachneigung',
            knee_wall: 'Kniestockhöhe'
          },
          values: {
            knee_wall: '{{number}} cm'
          },
          tooltips: {
            saddle_roof:
              'Klassischer Dachtyp in Dreiecksform mit zwei aufeinandertreffenden Dachflächen. Dachneigungen zwischen 30° bis über 60 ° sind möglich.',
            hipped_roof:
              'Zwei aufeinander zulaufende Dachflächen bei denen die Giebelseiten ebenfalls geneigt sind (wird als Walm bezeichnet). Dachneigungen ab 15° bis zu 40 ° sind möglich.',
            flat_roof: 'Abgeschlossene Dachform ohne Neigung',
            pent_roof:
              'Besteht nur aus einer geneigten Dachfläche. Dachneigungen von 11° bis 60° sind möglich.',
            tent_roof:
              'Seltene Dachform bei der alle Dachflächen in einem Punkt spitz zusammenlaufen (wie bei einer Pyramide).',
            half_hipped_roof: 'Walmdach mit hochgesetzter Traufhöhe am Giebel',
            mansard_roof:
              'Dachform mit unterschiedlichen Neigungen (im unteren Teil des Daches eine steilere Neigung und im oberen Teil des Daches eine flachere Neigung)',
            round_roof:
              'Seltene Dachform, welche gewölbt ist und in seinem Querschnitt ein Kreissegment darstellt.',
            knee_wall:
              'Wandhöhe an der das Dach im Obergeschoss aufliegt. Um die Wohnfläche bestmöglich auszunutzen, liegt der Kniestock meistens zwischen 40 und 80 Zentimeter. '
          },
          accordion: {
            headline: 'Überblick: Welche Dachformen gibt es?',
            saddle_roof: {
              headline: 'Satteldach',
              description:
                'Das Satteldach liegt in Form eines Dreiecks auf dem Baukörper und schließt entweder mit seinem First parallel zu den beiden Giebeln ab oder es ragt noch über die Giebel hinaus. Satteldächer werden als Pfettendach oder als Sparrendach ausgebildet. Üblich sind Dachneigungen ab etwa 30˚ (flaches Satteldach) bis über 60˚ (altdeutsches Dach). Weit verbreitet sind Satteldächer mit etwa 38˚ bis 45˚ Neigung. Diese bieten genug Raum für einen Ausbau des Dachgeschosses.'
            },
            tent_roof: {
              headline: 'Zeltdach',
              description:
                'Seltene Dachform, die nur auf einem quadratischen oder annähernd quadratischen Grundriß errichtet werden kann. Zelt- oder Pyramidendächer findet man vor allem auf Türmen und Kirchtürmen.'
            },
            hipped_roof: {
              headline: 'Walmdach',
              description:
                'Sehr häufig zu sehende Dachform, dem Satteldach verwandt. Im Gegensatz zu diesem schließt der First jedoch nicht mit den beiden Giebelwänden ab, sondern ist beidseitig zurückgebaut, das heißt abgeschrägt sind. Dabei unterscheidet man noch Zwergwalmdach, Krüppelwalmdach und Fußwalmdach. Da bei diesen Varianten nicht die komplette Seite abgewalmt ist, spricht man auch häufig von Vollwalmdach, wenn der Walm so ausgebildet ist, wie auf der Zeichnung. Weitere Bezeichnungen für Walmdach sind Walbendach, Holländisches Dach, Schopfdach oder Haubendach.'
            },
            half_hipped_roof: {
              headline: 'Krüppelwalmdach',
              description:
                'Besonders auf nord- und niederdeutschen Gehöften gebräuchliche Variante des Walmdachs. Entspricht einem Walmdach mit hochgesetzter Traufhöhe am Giebel. In manchen Gegenden wird es auch als Schopfwalmdach bezeichnet.'
            },
            flat_roof: {
              headline: 'Flachdach',
              description:
                'Flachdächer sind allgegenwärtig und dominieren im Gewerbebau, im Bereich des privaten Hausbaus werden sie - mit stark abnehmender Tendenz - bei Bungalows angelegt und natürlich bei Garagen und Carports. Bei Flachdächern erfolgt keine Dacheindeckung mit Dachpfannen, vielmehr wird die Dachfläche mit Dachbahnen oder mit Metallblechen regenfest gemacht. Konstruktiv wird beim Flachdach unterschieden zwischen Kaltdach, Warmdach und Umkehrdach. Mit Dachbahnen abgedichtete Flachdächer werden auch heute noch, wenn auch mit stark abnehmender Tendenz, mit Rollkies belegt. Stark steigend, bei Gewerbebauten jedoch oftmals auch baubehördlich vorgeschrieben, ist die Anlage einer Dachbegrünung. Dadurch wird das Flachdach zum Gründach. Gründächer sind eine sinnvolle Alternative gegen die zunehmende Verdichtung des Bodens. Flachdächer sind im übrigen keineswegs eben, sie müssen ein Gefälle von mindestens 3 % aufweisen, damit das Regenwasser über den Dachgully oder die Dachrinnen abfließen kann.'
            },
            pent_roof: {
              headline: 'Pultdach',
              description:
                'Gefälledach, das wie ein Pultdeckel auf dem Baukörper liegt. Das Pultdach ist die einfachste Dachform überhaupt. Mit nur einen schrägen Dachfläche ist es kostengünstig herzustellen. Im Mittelmeerraum ist das Pultdach die häufigste Dachform. Seit einiger Zeit erfreut es sich auch hierzulande zunehmender Beliebtheit. Die Dachfläche von Pultdächern liegt meist zur Wetterseite hin, um Wind, Regen und Schnee abzuschirmen. An der Sonnenseite lässt das Haus Raum für große Lichtflächen.'
            }
          }
        },
        description: {
          headline: 'Beschreibung für {{houseName}}',
          ctaBanner: {
            headline: 'Sie haben Interesse?',
            contentText:
              'Laden Sie sich jetzt Ihr kostenloses Exposé zu diesem Haus herunter:',
            buttonText: 'Exposé kostenlos herunterladen'
          }
        }
      },
      price: {
        headline: 'Preis',
        subheadline: 'Für {{houseName}}',
        mainCtaText: 'Persönliches Angebot anfordern',
        monthlyRateFrom: 'Monatliche Rate ab {{price}}',
        monthlyRateTitle: 'Geschätzte Monatsrate',
        monthlyRatePrice: 'ab {{price}}',
        financeAssistanceButton: 'Finanzierungen kostenlos vergleichen',
        keyreadyPriceFrom: 'Schlüsselfertig ab',
        legoPriceFrom: 'Bausatzhaus ab',
        fittingPriceFrom: 'Ausbauhaus ab',
        tooltip:
          'Der finale Gesamtpreis Ihres Hauses hängt u.a. von Ihrer persönlichen Haus-Konfiguration ab. Diese Übersicht kann Ihnen dabei als erste Orientierung dienen, um sich einen besseren Eindruck über den preislichen Einfluss der unterschiedlichen Optionen zu verschaffen.\nVoraussetzung für ein unverbindliches, individuelles Angebot ist ein persönliches Beratungsgespräch mit dem Anbieter.',
        disclaimer:
          'Dieser Preis ist ein Beispiel für den Anfang, ein Berater kann Ihnen ein detailliertes Angebot erstellen, das Ihren Bedürfnissen entspricht.',
        compareOffers: {
          headline: 'Möchten Sie bei Ihrem Projekt Geld sparen?',
          contentText: `Durch einen Angebotsvergleich mit {{domain}}.de können Sie bis zu 20 % Ihrer Baukosten sparen.`,
          buttonText: 'Angebote vergleichen & sparen'
        }
      }
    },
    image_gallery: {
      house_images: {
        tab_name: 'Bilder',
        headline: 'Möchten Sie mehr erfahren? ',
        contentText:
          'Erstellen Sie jetzt Ihr Konto und erhalten Sie Zugang zu Katalogen, Preisangeboten und Ihrem persönlichen Berater.',
        button_text: 'Kostenlose Infos anfordern'
      },
      floor_plans: {
        tab_name: 'Grundrisse',
        headline: 'Der Grundriss entspricht nicht Ihren Vorstellungen?',
        contentText:
          'Passen Sie den Grundriss an Ihre persönlichen Bedürfnisse an und besprechen Sie Ihren individuellen Plan mit einem Bauberater des Anbieters.',
        button_text: 'Kostenlose Anpassung anfragen',
        image_label: 'Grundriss #{{number}}'
      },
      videos: {
        tab_name: '360° Video'
      }
    },
    overview: 'Überblick',
    floor_plans: {
      title: 'Grundriss',
      'area-header': 'Außenmaße',
      length: 'Länge: {{length}} m',
      width: 'Breite: {{width}} m',
      'images-header': 'Grundrisse',
      'description-header':
        'Der Grundriss entspricht nicht Ihren Vorstellungen?',
      description:
        'Passen Sie den Grundriss an Ihre persönlichen Bedürfnisse an und besprechen Sie Ihren individuellen Plan mit einem Bauberater des Anbieters.',
      cta_button_text: 'Kostenlose Anpassung anfragen'
    },
    details: 'Details',
    price: 'Preis',
    houseOverview: {
      fromVendor: 'von {{vendorName}}',
      price: 'Ab {{price}}',
      'price-missing': 'Preis auf Anfrage',
      vendorLogoAltText: '{{vendorName}} logo'
    },
    heading_suffix: 'für {{houseName}}',
    fixedCTA: 'Preisdetails kostenlos anfordern',
    vendor: {
      'tab-name': 'Anbieter',
      'open-profile': 'Zum Anbieterprofil',
      'founding-year': 'Gründungsjahr',
      'houses-on-offer': 'Häuser im Angebot',
      'houses-per-year': 'Häuser pro Jahr',
      'houses-total': 'Häuser gesamt',
      employees: 'Mitarbeiter',
      'request-catalog': 'Katalog kostenlos anfordern',
      'range-of-services': 'Leistungsspektrum',
      'financing-advice': 'Finanzierungsberatung',
      'price-guarantee': 'Preisgarantie',
      'build-time-guarantee': 'Bauzeit Garantie',
      'individual-planning': 'Individuelle Planung',
      'blower-door-test': 'Blower Door Test',
      'personal-advice': 'Persönliche Beratung für Ihre individuellen Wünsche',
      'your-contact-at-vendor': 'Ihr Ansprechpartner von ',
      'find-your-contact-now': 'Finden Sie jetzt Ihren Ansprechpartner',
      'book-appointment': 'Jetzt Termin vereinbaren',
      awards: 'Auszeichnungen, Zertifikate & Mitgliedschaften',
      'more-houses': 'Weitere Häuser',
      'popular-houses-from-vendor': 'Beliebte Häuser von {{vendor}}',
      'all-houses': 'Alle Häuser',
      'all-houses-from-vendor': 'Alle Häuser von {{vendor}}',
      'customers-opinions': 'Kundenbewertungen',
      'reviews-amount-single': '1 Bewertung',
      'reviews-amount': '{{amount}} Bewertungen',
      'scroll-to-section': 'Bewertungen ansehen',
      'response-rate': '{{response_rate}}% negative Bewertungen beantwortet',
      'response-rate-none': 'Antwortrate der Bewertungen noch nicht verfügbar',
      'response-low-rating': 'Reagiert fast nie bei negativem Feedback',
      'response-medium-rating': 'Reagiert mäßig auf negatives Feedback',
      'response-high-rating': 'Reagiert sehr häufig bei Kundenfeedback',
      'vendor-in-numbers': '{{vendorName}} in Zahlen',
      'reviews-section': 'Bewertungen von {{vendorName}}',
      'all-reviews': 'Alle Bewertungen ansehen',
      'review-label': {
        excellent: 'Hervorragend',
        great: 'Gut',
        average: 'Akzeptabel',
        poor: 'Mangelhaft',
        bad: 'Ungenügend',
        none: 'Keine'
      }
    },
    'similar-houses': {
      title: 'Ähnliche Häuser',
      for: 'Für {{name}}'
    },
    pictures_and_floor_plans: 'Bilder & Grundrisse',
    breadcrumbs: {
      house_search: 'Häuser'
    },
    favourite: 'Speichern',
    'added-to-favourites': 'Gespeichert',
    'return-to-house-search': 'Zu den Suchergebnissen'
  },
  inactiveVendorHouses: {
    header: 'Dieses Haus ist zur Zeit nicht verfügbar',
    description:
      'Leider ist dieses Haus momentan nicht auf unserer Plattform verfügbar. Im Folgenden finden Sie Häuser die Ihren Kriterien ebenfalls entsprechen.',
    cta: 'Weitere Häuser anzeigen'
  }
}
